import {createNode} from "./common/ui";

(function () {
	const settings = {
		usa: {
			addressBlockCssClass: '.sys__address-block-usa',
			navigationAnchor: 'Kakpravilnoukazyvatadresdostavkivinternetmagazinax',
			addressKey: 'usaDe',
		},
		deu: {
			addressBlockCssClass: '.sys__address-block-de',
			navigationAnchor: 'KakpravilnoukazyvatadresdostavkivinternetmagazinaxGermaniiidrugixstranaxEvropy',
			addressKey: 'germany',
		},
		are: {
			addressBlockCssClass: '.sys__address-block-are',
			navigationAnchor: 'KakukazatadresdostavkivinternetmagazinaxOAE',
			addressKey: 'emirates',
		},
		tur: {
			addressBlockCssClass: '.sys__address-block-tr',
			navigationAnchor: 'Kakukazyvatadresnasajtaxtureckixmagazinov',
			addressKey: 'turkey',
		},
		chn: {
			addressBlockCssClass: '.sys__address-block-chn',
			navigationAnchor: 'kakukazatadresdostavkinasajtaxkitajskixinternetmagazinov',
			addressKey: 'china',
		},
	}

	function getWarehouseAddresses() {
		return null; //temp hide address block
		try {
			return JSON.parse(localStorage['warehouse_addresses']);
		} catch {
			return undefined;
		}
	}

	function createAddressLine(name, value) {
		const result = createNode('p', 'address-card__line');
		result.appendChild(createNode('span', 'address-card__line-name', {innerText: name}))
		result.appendChild(createNode('span', 'address-card__line-value', {innerText: value}))

		return result;
	}

	function createAddressLineExplanation(explanations) {
		const result = createNode('p', 'address-card__line');
		const explanationNode = createNode('div', 'address-card__explanation');

		for (let explanation of explanations) {
			explanationNode.appendChild(createNode('p', undefined, {innerHTML: explanation}));
		}

		result.appendChild(explanationNode);

		return result;
	}

	function createUsaAddress(address) {
		const content = createNode('div', 'help-block__content');

		content.appendChild(
			createNode(
				'p',
				undefined,
				{innerText: 'Скопируйте свой адрес из личного кабинета и вставьте текст в нужные поля на сайте интернет-магазина.'}
			)
		);

		const addressCard = createNode('div', 'address-card');

		addressCard.appendChild(createAddressLine('Full Name / Имя и Фамилия', address.fullName ?? '-'))
		addressCard.appendChild(createAddressLine('Address Line 1 / Улица', address.addressLine1 ?? '-'))
		addressCard.appendChild(createAddressLine('Address Line 2 / Номер квартиры или юнита, дом, этаж', address.addressLine2 ?? '-'))

		if (!!address.addressLine2 && typeof address.addressLine2 === 'string') {
			const clientIdParts = address.addressLine2.split('-');
			const clientId = clientIdParts[clientIdParts.length - 1].trim();
			addressCard.appendChild(createAddressLineExplanation([
				`${clientId} – это уникальный ID клиента &laquo;KUPI.SHOP&raquo;. По нему мы узнаем, чья посылка пришла на склад.`,
			]));
		}

		addressCard.appendChild(createAddressLine('ZIP/ Индекс', address.zip ?? '-'));
		addressCard.appendChild(createAddressLine('State/ Штат', address.state ?? '-'));
		addressCard.appendChild(createAddressLine('City/ Город', address.city ?? '-'));
		addressCard.appendChild(createAddressLine('Phone Number/ Телефон', address.phone ?? '-'));

		addressCard.appendChild(createAddressLineExplanation([
			'1-302-353-4515 – это телефон нашего склада. Используйте его только для заказов из интернет-магазинов.',
			'Для связи с «KUPI.SHOP» напишите на почту <a href="mailto:support@kupi.shop" class="help-block__link">support@kupi.shop</a>.',
		]));

		content.appendChild(addressCard);

		content.appendChild(
			createNode(
				'p',
				undefined,
				{innerText: 'Если в форме нет Address Line 2, добавьте информацию из этого поля в строку Address Line 1:'}
			)
		);

		const addressCard2 = createNode('div', 'address-card');
		addressCard2.appendChild(createAddressLine('Address Line 1 / Улица', `${address.addressLine1}, ${address.addressLine2}` ?? '-'));

		content.appendChild(addressCard2);

		return content;
	}

	function createDeAddress(address) {
		const content = createNode('div', 'help-block__content');

		content.appendChild(
			createNode(
				'p',
				undefined,
				{innerText: 'Точно так же, как и американский адрес. Просто скопируйте свои данные из личного кабинета «KUPI.SHOP» и вставьте в нужные поля на сайте онлайн-продавца. Поскольку вы можете совершать покупки не только в Германии, но и в других странах Евросоюза, мы приводим названия полей на немецком и английском языках.'}
			)
		);

		const addressCard = createNode('div', 'address-card');

		addressCard.appendChild(createAddressLine('Name Vorname/ Name (Имя полностью)', address.fullName ?? '-'))
		addressCard.appendChild(createAddressLine('Firmenname oder Name2/ Company (Название фирмы)', address.company ?? '-'))

		if (!!address.company && typeof address.company === 'string') {
			addressCard.appendChild(createAddressLineExplanation([
				`${address.company} — это уникальный ID клиента «KUPI.SHOP». По нему мы узнаем, чья посылка пришла на склад.<br/>
				 Внимание: скопируйте и вставьте в форму магазина всю информацию из этого поля, включая ECOM MF. Если на сайте магазина нет такого пункта, укажите эту информацию в поле Adresszusatz (Дополнительная информация).`,
			]));
		}

		addressCard.appendChild(createAddressLine('Straße, Nummer/ Address (Улица, Номер дома)', `${address.street} ${address.house}`));

		addressCard.appendChild(createAddressLine('Postleitzahl/ ZIP (Почтовый индекс)', address.zip ?? '-'));
		addressCard.appendChild(createAddressLine('Ort/ City (Город)', address.city ?? '-'));
		addressCard.appendChild(createAddressLine('Kontakt Mobil/ Phone (Номер телефона)', address.tel ?? '-'));

		content.appendChild(addressCard);

		return content;
	}

	function createAreAddress(address) {
		const content = createNode('div', 'help-block__content');

		content.appendChild(
			createNode(
				'p',
				undefined,
				{innerText: 'Скопируйте свой адрес из личного кабинета и вставьте в форму на сайте магазина. Обратите внимание, что поле Company содержит ваш ID, поэтому название компании нужно обязательно сообщить продавцу при заказе товара.'}
			)
		);

		const addressCard = createNode('div', 'address-card');

		addressCard.appendChild(createAddressLine('Full Name (Имя полностью)', address.fullName ?? '-'))
		addressCard.appendChild(createAddressLine('Company (Название фирмы)', address.company ?? '-'))

		if (!!address.company && typeof address.company === 'string') {
			const clientId = address.company.match(/(A\d{6})/)[0];
			addressCard.appendChild(createAddressLineExplanation([
				`${clientId} — это уникальный ID клиента «KUPI.SHOP». По нему мы узнаем, чья посылка пришла на склад.<br/>
				 Если в форме магазина нет поля для названия фирмы, добавьте эту информацию в поле Building №/ House №. Не забудьте скопировать название компании полностью, так, как оно указано в вашем личном кабинете.`,
			]));
		}
		addressCard.appendChild(createAddressLine('Country', address.country ?? 'UAE'));
		addressCard.appendChild(createAddressLine('City', address.city ?? '-'));
		addressCard.appendChild(createAddressLine('Area (Район)', address.area ?? '-'));
		addressCard.appendChild(createAddressLine('Street / Landmark', address.street ?? '-'));
		addressCard.appendChild(createAddressLine('Building No. / Appartment', address.building ?? '-'));
		addressCard.appendChild(createAddressLine('Phone (Номер телефона)', address.tel ?? '-'));

		content.appendChild(addressCard);

		return content;
	}

	function createTrAddress(address) {
		const content = createNode('div', 'help-block__content');

		content.appendChild(
			createNode(
				'p',
				undefined,
				{
					innerText: 'Схема та же, что и для других направлений. Скопируйте свои данные и вставьте в нужные поля на сайте магазина. Информацию нужно переносить полностью, так, как она указана в вашем личном кабинете.'
				}
			)
		);

		const addressCard = createNode('div', 'address-card');

		addressCard.appendChild(createAddressLine('Ad, Soyad (Имя полностью)', address.fullName ?? '-'))
		addressCard.appendChild(createAddressLine('Şehir / İl (Город / Провинция)', address.city ?? '-'));
		addressCard.appendChild(createAddressLine('İlçe (Округ)', address.county ?? '-'));
		addressCard.appendChild(createAddressLine('Mahalle (Район)', address.area ?? '-'));
		addressCard.appendChild(createAddressLine('Adres (Адрес)', address.address ?? '-'));
		if (!!address.address && typeof address.address === 'string') {
			const clientId = address.address.match(/(PS-\d{6})/)[0];
			addressCard.appendChild(createAddressLineExplanation([
				`${clientId} — это уникальный ID клиента «KUPI.SHOP». По нему мы узнаем, чья посылка пришла на склад.`,
			]));
		}
		addressCard.appendChild(createAddressLine('Posta kodu (Индекс)', address.postalCode ?? '-'));
		addressCard.appendChild(createAddressLine('Telefon (Телефон)', address.tel ?? '-'));
		addressCard.appendChild(createAddressLineExplanation([
			`В некоторых магазинах телефон нужно указывать без +9: 05331451787`,
		]));
		addressCard.appendChild(createAddressLine('Fatura tipi (Тип счёта)', address.type ?? '-'));
		content.appendChild(addressCard);

		return content;
	}

	function createChnAddress(address) {
		const content = createNode('div', 'help-block__content');

		content.appendChild(createNode('p', undefined, {
			innerText: 'Скопируйте информацию из личного кабинета и вставьте её в форму на сайте магазина. На некоторых площадках предусмотрено только одно поле для адреса. В этом случае впишите сначала провинцию, затем город, район и все остальные данные из нашей графы «Адрес».'
		}));
		content.appendChild(createNode('p', undefined, {
			innerText: 'Для вашего удобства мы прописали адрес не только иероглифами, но и латиницей – для сайтов, у которых есть англоязычная версия.'
		}));
		content.appendChild(createNode('p', undefined, {
			innerText: 'Пожалуйста, переносите информацию полностью, так, как она дана в вашем личном кабинете.'
		}));

		const addressCard = createNode('div', 'address-card');

		addressCard.appendChild(createAddressLine('省 (Провинция)', address.province ?? '-'))
		addressCard.appendChild(createAddressLine('城市 (Город)', address.city ?? '-'))
		addressCard.appendChild(createAddressLine('区 (Район)', address.area ?? '-'))
		addressCard.appendChild(createAddressLine('地址 (Адрес)', address.address ?? '-'))
		addressCard.appendChild(createAddressLine('邮政编码 (Индекс)', address.postalCode ?? '-'))
		addressCard.appendChild(createAddressLine('收货人姓名 (Получатель)', address.recipient ?? '-'))

		if (!!address.recipient && typeof address.recipient === 'string') {
			const clientId = address.recipient.match(/( \d{6})/)[0];
			addressCard.appendChild(createAddressLineExplanation([
				`На сайте магазина в поле 收货人姓名 (Получатель) указывайте 黄雷刚 Mr Huang Leigang, а не своё имя. Не удаляйте из адреса ${clientId}. Это ваш уникальный ID, по нему мы узнаем, что получили на складе именно вашу посылку.`,
			]));
		}

		addressCard.appendChild(createAddressLine('手机号码 (Телефон)', address.phone ?? '-'))
		addressCard.appendChild(createAddressLineExplanation(['Пожалуйста, не добавляйте к номеру телефона «+» или какие-то другие цифры.']));

		content.appendChild(addressCard);

		return content;
	}

	function initWarehouseAddresses() {
		const warehouseAddresses = getWarehouseAddresses();

		const usaAddressBlock = document.querySelector(settings.usa.addressBlockCssClass);
		if (!!warehouseAddresses && warehouseAddresses.hasOwnProperty(settings.usa.addressKey)) {
			usaAddressBlock.appendChild(createUsaAddress(warehouseAddresses[settings.usa.addressKey]));
		} else {
			usaAddressBlock.style.display = 'none';
			document.querySelector(`[data-anchor-id=${settings.usa.navigationAnchor}`).style.display = 'none';
		}

		const deAddressBlock = document.querySelector(settings.deu.addressBlockCssClass);
		if (!!warehouseAddresses && warehouseAddresses.hasOwnProperty(settings.deu.addressKey)) {
			deAddressBlock.appendChild(createDeAddress(warehouseAddresses[settings.deu.addressKey]))
		} else {
			deAddressBlock.style.display = 'none';
			document.querySelector(`[data-anchor-id=${settings.deu.navigationAnchor}`).style.display = 'none';
		}

		const chnAddressBlock = document.querySelector(settings.chn.addressBlockCssClass);
		if (!!warehouseAddresses && warehouseAddresses.hasOwnProperty(settings.chn.addressKey)) {
			chnAddressBlock.appendChild(createChnAddress(warehouseAddresses[settings.chn.addressKey]))
		} else {
			chnAddressBlock.style.display = 'none';
			document.querySelector(`[data-anchor-id=${settings.chn.navigationAnchor}`).style.display = 'none';
		}
	}

	document.addEventListener('DOMContentLoaded', function () {
		initWarehouseAddresses();
	});
})();
